import { FC, ReactElement } from "react";
import { Button, Form } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { exportProductCapabilitiesAction, setIncludeInactiveAction } from "../redux/ProductCapabilitiesActions";

interface Props {
  plantCode: string;
}

export const ProductCapabilitiesExportSection: FC<Props> = ({ plantCode }): ReactElement => {
  const dispatch = useDispatch();
  const { exporting, includeInactive } = useSelector(
    (state: any) => ({
      exporting: state.productCapabilities.exporting,
      includeInactive: state.productCapabilities.includeInactive,
    }),
    shallowEqual
  );

  const handleExport = () => {
    dispatch(exportProductCapabilitiesAction(plantCode, includeInactive) as any);
  };

  return (
    <div data-testid="product-capabilities-export-section">
      <h4>Export</h4>
      <Form.Check
        type="checkbox"
        id="product-capabilities-include-inactive"
        label="Include inactive"
        checked={includeInactive}
        onChange={(e) => dispatch(setIncludeInactiveAction(e.target.checked))}
        data-testid="product-capabilities-include-inactive-checkbox"
      />
      <Button
        variant="primary"
        onClick={handleExport}
        disabled={exporting || !plantCode}
        data-testid="product-capabilities-export-button"
        className="mt-2"
      >
        {exporting ? "Exporting…" : "Download CSV"}
      </Button>
    </div>
  );
};
